import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: "pkce",
  },
});

// Helpers ────────────────────────────────────────────────────────────────

// Combine offers.date (date) + offers.start_time (time) into a JS Date
export const offerStartsAt = (offer) => {
  if (!offer?.date || !offer?.start_time) return null;
  // start_time may be "HH:MM:SS" or "HH:MM"; ensure ISO format
  const t = offer.start_time.length === 5 ? `${offer.start_time}:00` : offer.start_time;
  return new Date(`${offer.date}T${t}`);
};

// Current effective price - prefer offer_price, fallback to price
export const offerCurrentPrice = (offer) => {
  if (offer == null) return 0;
  if (offer.offer_price != null) return Number(offer.offer_price);
  if (offer.price != null) return Number(offer.price);
  return Number(offer.original_price || 0);
};

export const offerOriginalPrice = (offer) => Number(offer?.original_price ?? offerCurrentPrice(offer));

export const offerDiscountPct = (offer) => {
  const orig = offerOriginalPrice(offer);
  const cur = offerCurrentPrice(offer);
  if (!orig || orig <= cur) return 0;
  return Math.round(((orig - cur) / orig) * 100);
};
